// extracted by mini-css-extract-plugin
module.exports = {"UserCard":"UserCard_UserCard__3gStk","avatar":"UserCard_avatar__EcCNz","textBlock":"UserCard_textBlock__1SLkZ","email":"UserCard_email__3cQVZ"};